/**
 * Border width tokens for consistent border styling
 * Values are in pixels, not spacing multipliers
 */

export const borderWidth = {
  none: 0,     // 0px - no border
  thin: 1,     // 1px - standard border
  medium: 2,   // 2px - thicker border
  thick: 3,    // 3px - thick border
} as const

export type TBorderWidth = keyof typeof borderWidth
